import script from "./ScadenzeCalendarDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ScadenzeCalendarDialog.vue?vue&type=script&setup=true&lang=js"

import "./ScadenzeCalendarDialog.vue?vue&type=style&index=0&id=17a614e5&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a614e5"]])

export default __exports__